import { combineReducers } from "redux";
import { staffingReducer } from "./staffing/staffingReducer";
import { pedagogicalReducer } from "./pedagogical/pedagogicalReducer";
import { awardsReducer } from "./awards/awardsReducer";


export const dataReducer = combineReducers({
    staffing: staffingReducer,
    pedagogical: pedagogicalReducer,
    awards: awardsReducer,
});
